import { NavLink } from 'react-router-dom';
import { useSidebar } from '../../context/SidebarContext';
import { useAuth } from '../../context/AuthContext';
import shortLogo from '../../assets/images/he-short-logo.png';
import horizontalLogo from '../../assets/images/he-horizontal-logo.png';
import './Sidebar.css';

const navGroups = [
  {
    label: 'Menu',
    items: [
      { path: '/app/dashboard',  label: 'Dashboard',  icon: 'dashboard' },
      { path: '/app/enquiries',  label: 'Enquiries',  icon: 'inbox' },
      { path: '/app/leads',      label: 'Leads',      icon: 'contacts' },
      { path: '/app/customers',  label: 'Customers',  icon: 'group' },
    ],
  },
  {
    label: 'Sales',
    items: [
      { path: '/app/templates',  label: 'Templates',  icon: 'content_copy' },
      { path: '/app/quotations', label: 'Quotations', icon: 'request_quote' },
      { path: '/app/invoices',   label: 'Invoices',   icon: 'description' },
      { path: '/app/agreements', label: 'Agreements', icon: 'handshake' },
    ],
  },
  {
    label: 'System',
    items: [
      { path: '/app/terms',   label: 'Terms & Conditions', icon: 'gavel' },
      { path: '/app/reports', label: 'Reports',            icon: 'analytics' },
    ],
  },
];

const getInitials = (name = '') =>
  name
    ? name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2)
    : 'U';

const Sidebar = () => {
  const { isOpen, isMobile, closeSidebar } = useSidebar();
  const { user } = useAuth();

  const sidebarClasses = ['sidebar', isOpen && isMobile ? 'open' : ''].filter(Boolean).join(' ');

  // Running index across all groups so the entry animation staggers smoothly
  let itemIndex = 0;

  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen && isMobile ? 'open' : ''}`}
        onClick={closeSidebar}
        aria-hidden="true"
      />

      <aside className={sidebarClasses}>
        {/* Logo — cross-fades between short and horizontal on expand */}
        <div className="sidebar-header">
          <img src={shortLogo} alt="HE" className="sidebar-logo-short" />
          <img src={horizontalLogo} alt="Haughton Elevators" className="sidebar-logo-horizontal" />
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navGroups.map((group) => (
            <div className="sidebar-group" key={group.label}>
              <span className="sidebar-group-label">{group.label}</span>
              {group.items.map((item) => {
                const i = itemIndex++;
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    title={item.label}
                    style={{ '--i': i }}
                    className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
                    onClick={() => isMobile && closeSidebar()}
                  >
                    <span className="material-symbols-outlined">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        {/* Footer — profile chip linking to settings */}
        <div className="sidebar-footer">
          <NavLink
            to="/app/settings"
            className="sidebar-profile"
            title="Settings"
            onClick={() => isMobile && closeSidebar()}
          >
            <span className="sidebar-profile-avatar">{getInitials(user?.name)}</span>
            <span className="sidebar-profile-info">
              <span className="sidebar-profile-name">{user?.name || 'User'}</span>
              <span className="sidebar-profile-role">{user?.group || 'Member'}</span>
            </span>
            <span className="material-symbols-outlined sidebar-profile-cog">settings</span>
          </NavLink>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
